<template lang="pug">
v-container(fluid class=" tw-h-full tw-w-full")
  v-row(no-gutters align="center" justify="center" class="tw-w-full tw-h-full")
    v-col(class="tw-rounded-md tw-h-full tw-w-full tw-ml-2 tw-flex tw-flex-col ")
      v-row(class="  tw-flex !tw-flex-shrink-default ")
        v-col
          span(class="tw-text-2xl tw-text-indigo-lighten-1 tw-font-bold tw-capitalize") {{ $t('Profile.Common.editProfile') }}
      v-row(align="start" class="  tw-flex tw-flex-row !tw-flex-grow-defaul tw-h-full ")
        v-col
          v-row(align="center" class="")
            v-col(cols="auto")
              template(v-if="!user.profile_photo_path")
                v-img(
                  :src="require('@/assets/images/placeholder-image.jpg')"
                  cover
                  class="tw-rounded tw-border tw-border-blueGray-darken-1"
                  width="80px"
                  height="80px"
                )
              template(v-else)
                div(class="tw-h-20 tw-w-20 tw-overflow-hidden")
                  v-img(
                    :src="path(user.profile_photo_path)"
                    cover
                    class="tw-rounded tw-border tw-border-blueGray-darken-1 tw-w-full tw-h-full"
                  )
            v-col
              v-row(no-gutters)
                v-col
                  v-file-input(
                    v-model="profilePhoto"
                    :label="$t('Profile.Common.profilePhoto')"
                    outlined
                    hide-details
                    class="tw-capitalize"
                  ) 
          v-row
            v-col
              v-text-field(v-model="user.name" :label="$t('Common.name')" outlined hide-details class="tw-capitalize")
            v-col
              v-text-field(
                v-model="user.last_name"
                :label="$t('Contacts.Common.lastName')"
                outlined
                hide-details
                class="tw-capitalize"
              )
          v-row
            v-col
              v-text-field(v-model="user.email" :label="$t('Common.email')" outlined hide-details)
            v-col
              v-text-field(v-model="user.phone" :label="$t('Common.phone')" outlined hide-details)
      v-row(no-gutters justify="end" class="  tw-flex tw-flex-row !tw-flex-shrink-default")
        v-col(cols="auto" align-self="end")
          v-btn(
            elevation="0"
            @click="update"
            :loading="loading"
            color="rgba(94,129,244,0.80)"
            class="tw-bg-kPurple tw-rounded"
          ) {{ $t('Common.save') }}
</template>
<script>
export default {
  data() {
    return {
      user: {},
      loading: false,
      profilePhoto: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch('user/getUserProfile', this.$store.state.auth.user.id).then(() => {
        this.user = JSON.parse(JSON.stringify(this.$store.getters['user/profile']));
      });
    },
    update() {
      this.loading = true;
      const payload = new FormData();
      payload.append('name', this.user.name);
      payload.append('email', this.user.email);
      payload.append('phone', this.user.phone);
      payload.append('last_name', this.user.last_name);
      payload.append('_method', 'put');
      if (this.profilePhoto) {
        payload.append('photo', this.profilePhoto);
      }
      this.$store.dispatch('user/update', payload).then(() => {
        this.init();
        this.loading = false;
        this.profilePhoto = null;
      });
    },
  },
};
</script>
